export const DEFAULT_USER_NICKNAME = '匿名用户';

export const DEFAULT_USER_DESCRIPTION = '这个人很神秘，什么也没有留下！';

export const DEFAULT_USER_AVATAR =
  'https://sma1lbao.cn/upload/public/images/avatar.png';

export const DEFAULT_HOLDER =
  'https://sma1lbao.cn/upload/public/images/logo.png';

export const DEFULAT_SHADOW_COVER = '';

export const DEFAULT_PROFILE_COVER =
  'https://sma1lbao.cn/upload/public/images/profile-short.jpeg';

export const LOGIN_IMAGES = [
  'https://sma1lbao.cn/upload/public/images/login-holder.jpeg',
];
